import React from "react";
import logo from "../assets/images/logo.png";

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader-content">
        <img src={logo} alt="Loading" className="loader-logo" />
        <div className="loader-ring"></div>
      </div>
    </div>
  );
};

export default PageLoader;
